import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { PushDevicesDataService, PushDevicesColumnsService } from '../../../services';
import { PushDevice, PushDevicesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-push-device-details',
  templateUrl: './push-device-details.component.html',
  styleUrls: ['./push-device-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class PushDeviceDetailsComponent implements OnInit, OnDestroy {

  public pushDevice: PushDevice = {};
  public pushDevices: PushDevice[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private pushDevicesDataService: PushDevicesDataService,
    private pushDevicesColumnsService: PushDevicesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Push Device - Details');
        this.getPushDevice(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.pushDevice !== 'undefined') {
      this.pushDevice = this.dynamicDialogConfig.data.pushDevice;
    }
    this.columns = this.pushDevicesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getPushDevice(id: number): void {
    this.isLoading = true;
    this.pushDevicesDataService.getPushDevice(id).subscribe((response: PushDevice|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.pushDevice = response;
      }
    });
  }

  list() {
    this.router.navigate(['/push-devices']);
  }

  add() {
    this.router.navigate(['/push-devices/add']);
  }

  edit() {
    this.router.navigate(['/push-devices/edit/' + this.pushDevice.id]);
  }

}
@Component({
  selector: 'app-push-device-details',
  templateUrl: './push-device-details.component.html',
  styleUrls: ['./push-device-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogPushDeviceDetailsComponent extends PushDeviceDetailsComponent {
}

